type Field = {
  title: string
  usdValue: string
  aedValue: string
}

type WireTransferDetails = Record<string, Field>

type BankDetails = {
  wireTransferDetails: WireTransferDetails
}

const bankDetails: BankDetails = {
  wireTransferDetails: {
    beneficiaryName: {
      title: 'BENEFICIARY NAME:',
      usdValue: 'Credibila Markets',
      aedValue: 'Credibila Markets',
    },
    cif: {
      title: 'CIF:',
      usdValue: '00900102178',
      aedValue: '00900102178',
    },
    iban: {
      title: 'IBAN:',
      usdValue: 'MU80STCB1170000000812384000USD',
      aedValue: 'MU68STCB1170000000812414000AED',
    },
    accountNumber: {
      title: 'ACCOUNT NUMBER:',
      usdValue: '50100000812384',
      aedValue: '50100000812414',
    },
    beneficiaryBank: {
      title: 'BENEFICIARY’S BANK:',
      usdValue: 'SBM Bank (Mauritius) Limited',
      aedValue: 'SBM Bank (Mauritius) Limited',
    },
    bankAddress: {
      title: 'BANK ADDRESS:',
      usdValue: '6th Floor SBM Tower, Port Louis',
      aedValue: '6th Floor SBM Tower, Port Louis',
    },
    swiftCode: {
      title: 'SWIFT CODE:',
      usdValue: 'STCBMUMU',
      aedValue: 'STCBMUMU',
    },
    intermediaryBank: {
      title: 'INTERMEDIARY / CORRESPONDENT BANK:',
      usdValue: 'Citibank NA, New York',
      aedValue: 'Standard Chartered Bank, Dubai City, AE',
    },
    intermediaryAccountNumber: {
      title: 'ACCOUNT NUMBER:',
      usdValue: '36004679',
      aedValue: '15209926501',
    },
    intermediarySwiftCode: {
      title: 'SWIFT CODE:',
      usdValue: 'CITI US 33',
      aedValue: 'SCBLAEAD',
    },
  },
}
export default bankDetails
